module.exports = __webpack_public_path__ + "static/img/image2.0d6c6686.png";